/**
 * عرض وصف التحدي (HTML من المحرر) — إزالة سكربتات بسيطة قبل innerHTML.
 */
export function sanitizeChallengeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/\son\w+\s*=\s*["'][^"']*["']/gi, '')
    .replace(/\son\w+\s*=\s*[^\s>]*/gi, '');
}
